import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { SummaryResponse } from '../models/summary-response.model';
import { SummaryRepository } from '../repositories/summary.respository';

export class GetSummaryUseCase implements UseCase<never, SummaryResponse> {
    constructor(private readonly repository: SummaryRepository) {}

    execute(): Observable<SummaryResponse> {
        return this.repository.getSummary();
    }
}
